import React from 'react';
import {TableRow, TableRowColumn} from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';

export default function ContactRow(props) {
  return (
    <TableRow key={props.contact._id}>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.contact.firstName}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace: 'normal'}}>
        {props.contact.lastName}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.contact.title}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.contact.phoneNumber}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.contact.emailAddress}
      </TableRowColumn>
      <TableRowColumn>
          <FlatButton label="Poista" onTouchTap={() => props.onContactDelete(props.rowNumber)}/>
      </TableRowColumn>
    </TableRow>
  );
}



// WEBPACK FOOTER //
// ./src/components/FrontPage/ContactRow.js